export default __webpack_public_path__ + "static/media/kura.2e9da0c3.svg";